import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import DomTypeDelivery1 from "../../images/dom_pin_1.svg";
import DomTypeDelivery2 from "../../images/dom_pin_2.svg";
import CounterConponent from "../../components/Counter";
import DatePickerComponent from "../../components/Datepicker";
import SawasdeeContext from "./SawasdeeContext";
import { DateUtils } from "../../utils";
import SelectComponent from "../../components/Select";
import { Alert } from "../../utils";
import { TYPE_CODES } from "../../const";
import DataService from "../../service/data";
import InfoIconComponent from "../../components/InfoIcon";
import CalculateService from "../../service/calulate";
import {
  PURPOSE_OF_TOURISM,
  TYPE_DETAILS,
  DESTINATION_COUNTRY
} from "../../data/international";
import { SpaceBox } from "../../components/Space";
import moment from 'moment';
import CheckBoxComponent from '../../components/CheckBox';

class InternationalStep1 extends Component {
  setCounterState;

  state = {
    nationals: []
  };
  constructor(props) {
    super(props);
    setTimeout(() => {
      this._checkCounterWithType();
    }, 1);
    setTimeout(() => {
      this.initData();
    }, 1);
  }

  async initData() {
    try {
      const callers = [];
      callers.push(DataService.getNationalities());
      const responses = await Promise.all(callers);

      this.setState({
        ...this.state,
        nationals: responses[0]
      });
    } catch (err) {
      console.log(err);
    }
  }

  _onChangeType = value => {
    const { onChangeModel, getPlan, usertype, } = this.context.step1;
    if(usertype != value) {
      onChangeModel({ name: "usertype", value });
      this._checkCounterWithType();
  
      const isFirstType = value === 1;
      const counter = isFirstType ? 1 : 2;
      onChangeModel({ name: "counter", value: counter });
      getPlan();
    }
  };

  _checkCounterWithType() {
    const { usertype, onChangeModel } = this.context.step1;
    const isFirstType = usertype === 1;
    const minCount = isFirstType ? 1 : 2;
    const maxCount = isFirstType ? 5 : 4;
    if (this.setCounterState) {
      this.setCounterState({ minCount, maxCount });
    }
  }

  onChangePurpose = selected => {
    const { onChangeModel } = this.context.step1;
    onChangeModel({ name: "purposeTour", value: selected });
    onChangeModel({ name: "purposeTourOther", value: "" });
    setTimeout(() => {
      const txtpurposeTourOther = document.getElementById("purposeTourOther");
      if (txtpurposeTourOther) {
        txtpurposeTourOther.focus();
      }
    }, 100);
  };

  _onSelectDestinationCountry = selected => {
    const {
      onChangeModel,
      destinationCountry,
      countryZone,
      onChangeZone
    } = this.context.step1;
    if (selected && selected.length > 3) {
      Alert.alertWithTitle(
        " กรุณากรอกข้อมูลให้ถูกต้อง",
        "กรณีที่ท่านเลือกการเดินทางมากกว่า 3 ประเทศ กรมธรรม์จะให้ความคุ้มครองทุกประเทศทั่วโลกโดยอัตโนมัติ ยกเว้น การเดินทาง หรือการกระทำใดที่ระบุไว้ในข้อยกเว้นทั่วไปของกรมธรรม์",
        "warning"
      );
    } else {
      onChangeModel({ name: "destinationCountry", value: selected });
      onChangeZone({ name: "countryZone" });
    }
  };

  _getCountryList() {
    const { destinationCountry } = this.context.step1;
    const { nationals } = this.state;
    if (destinationCountry) {
      const isDisabledAsia = destinationCountry.some(
        country =>
          country.value === "WORLDWIDE" ||
          country.value === "Shcengen Group Countries"
      );
      if (isDisabledAsia) {
        return DESTINATION_COUNTRY.map(country => {
          if (country.value === "ASIA") {
            return { ...country, isDisabled: true };
          }
          return country;
        });
      }
      const isAsia = destinationCountry.some(
        country => country.value === "ASIA"
      );
      if (isAsia) {
        return DESTINATION_COUNTRY.map(country => {
          if (
            country.value === "WORLDWIDE" ||
            country.value === "Shcengen Group Countries"
          ) {
            return { ...country, isDisabled: true };
          }
          return country;
        });
      }
    }
    return DESTINATION_COUNTRY;
  }

  render() {
    const { diffDate, step1 } = this.context;
    const {
      type,
      start_date,
      end_date,
      onChangeModel,
      purposeTour,
      purposeTourOther,
      usertype,
      counter,
      destinationCountry,
      visa,
      onChangeDate,
      onOneTrip,
      onYearTrip
    } = step1;

    const today = new Date(DateUtils.getCurrentTh("YYYY-MM-DD"));
    const minEndDate = start_date ? new Date(DateUtils.getCurrentPlusOneTh(start_date, 'YYYY-MM-DD')) : today;

    return (
      <div className="form-wrapper">
        {/* ################## */}
        {/* Select Travel Type */}
        {/* ################## */}
        <div className="form-group">
          <label>ประเภทการเดินทาง</label>
          <div className="d-flex">
            <div
              className={`radio-button ${usertype === 1 ? "active" : ""}`}
              onClick={this._onChangeType(1)}
            >
              <div className="radio" />
              <p>รายเดี่ยว</p>
            </div>
            <div className='radio-button'></div>
          </div>
          <div className="usertype-msg">
            {TYPE_DETAILS[usertype - 1].details}
          </div>
        </div>

        {/* ################## */}
        {/* End Travel Type */}
        {/* ################## */}

        {/* ################## */}
        {/* Select Country */}
        {/* ################## */}
        <div className="form-group">
          <label>ประเทศปลายทาง</label>

          <InfoIconComponent
            id="destinationCountry"
            text="ประเทศปลายทางที่ไม่คุ้มครอง: เกาหลีเหนือ, คิวบา, ซีเรีย, ซูดาน,
              บุรุนดี, ปากีสถาน, ปาเลสไตน์, รวันดา, ลิเบีย, เลบานอน, ไลบีเรีย,
              อัฟกานิสถาน, อาเซอร์ไบจาน, อิรัก, อิสราเอล, อิหร่าน, อุซเบกิสถาน,
              เอธิโอเปีย, เอริเทรีย, แองโกลา, แอลจีเรีย และเฮติ"
          />

          <div className="d-flex">
            <SelectComponent
              closeMenuOnSelect={false}
              options={this._getCountryList()}
              selected={destinationCountry}
              onChange={this._onSelectDestinationCountry}
              isMulti
            />
          </div>
          <p className="text-helper text-small">
            * โปรดศึกษารายละเอียดประเทศปลายทางที่ไม่คุ้มครอง จำนวน 22 ประเทศ
          </p>
        </div>
        {/* ################## */}
        {/* End Country */}
        {/* ################## */}
        <div className="form-group">
          <label>รูปแบบการเดินทาง</label>
          <div className="d-flex">
            <div
              className={`rectangle ${type === 1 ? "active" : ""}`}
              onClick={() => {
                if(type != 1) {
                  onOneTrip();
                }
              }}
            >
              <img
                className="m-auto"
                src={DomTypeDelivery1}
                width="24px"
                height="24px"
              />
              <p>รายเที่ยว</p>
            </div>
            <div
              className={`rectangle ${type === 2 ? "active" : ""}`}
              onClick={() => {
                if(type != 2) {
                  onYearTrip();
                }
              }}
            >
              <img
                className="m-auto"
                src={DomTypeDelivery2}
                width="24px"
                height="24px"
              />
              <p>รายปี</p>
            </div>
          </div>
        </div>
        {/* ################## */}
        {/** Start - End Date **/}
        {/* ################## */}
        <div className="form-group">
          <div className="d-flex">
            <label>
              วันที่เดินทาง{" "}
              <InfoIconComponent id="diffDateInter" text="เวลาเริ่ม 00.01 น.-เวลาสิ้นสุดการคุ้มครอง 24.00 น." />
            </label>
            <div className="ml-auto">
              <p className="text-dark-blue">
                {
                  type === 2 ? 
                  (<><b>{diffDate != '-' ? "1" : diffDate}</b> ปี</>) :
                  (<><b>{diffDate}</b> วัน</>) 
                }
                {/* <b>{diffDate}</b> { type === 2 ? 'ปี' : 'วัน' } */}
              </p>
            </div>
          </div>
          <div className="d-flex">
            <DatePickerComponent
              minDate={today}
              maxDate={end_date ? new Date(end_date) : ""}
              selected={start_date ? new Date(start_date) : ""}
              placeholderText="วันที่เริ่มต้น"
              onChange={date =>
                onChangeDate({ name: "start_date", value: date })
              }
              dateFormat="dd/MM/yyyy"
              showTimeSelect={false}
              popperPlacement="top-start"
            />
            <SpaceBox />
            <DatePickerComponent
              minDate={minEndDate}
              disabled={type === 2}
              selected={end_date ? new Date(end_date) : ""}
              placeholderText="วันที่สิ้นสุด"
              onChange={date => onChangeDate({ name: "end_date", value: date })}
              dateFormat="dd/MM/yyyy"
              popperPlacement="top-end"
              showTimeSelect={false}
            />
          </div>
          <p className="text-helper text-small">
            * กรุณาซื้อกรมธรรม์ก่อนการเดินทางออกจากประเทศไทย ล่วงหน้าอย่างน้อย 2
            ชั่วโมง
          </p>
        </div>
        {/* ################## */}
        {/*** End Date Picker **/}
        {/* ################## */}

        {/* ################## */}
        {/*** Counter Section **/}
        {/* ################## */}
        <div className="form-group">
          <div className="d-flex align-item-center">
            <label className="mb-0 ml-3">จำนวนผู้เอาประกัน</label>
            <CounterConponent
              init={setCounterState => (this.setCounterState = setCounterState)}
              counter={counter}
              onChange={counter =>
                onChangeModel({ name: "counter", value: counter })
              }
              className="ml-auto mr-3"
            />
          </div>
        </div>
        {/* ################## */}
        {/* End Counter Section */}
        {/* ################## */}

        <div className="form-group">
          <label>วัตถุประสงค์ของการท่องเที่ยว</label>
          <div className="d-flex">
            <SelectComponent
              options={PURPOSE_OF_TOURISM}
              selected={purposeTour}
              onChange={this.onChangePurpose}
            />
            {purposeTour && purposeTour.value === "อื่นๆ" && (
              <Fragment>
                <SpaceBox />
                <input
                  id="purposeTourOther"
                  type="text"
                  className="form-control"
                  placeholder="อื่นๆ"
                  name="purposeTourOther"
                  value={purposeTourOther}
                  onChange={e =>
                    onChangeModel({
                      name: e.target.name,
                      value: e.target.value
                    })
                  }
                />
              </Fragment>
            )}
          </div>
        </div>
        <div className="form-group ml-4">
          <CheckBoxComponent 
              text="ยื่นเอกสารขอวีซ่า"
              checked={visa}
              onChange={(checked) =>{
                let value = checked ? 1 : 0
                onChangeModel({ name: "visa", value: value })
              }}
          />
        </div>
      </div>
    );
  }
}

InternationalStep1.contextType = SawasdeeContext;
export default withRouter(InternationalStep1);
